import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/auth";
import RefreshTokenModule from "./modules/refresh-token";
import audio from './modules/audio';
import testimonial from './modules/testimonial';
import video from './modules/video';
import user from './modules/user';
import speaker from './modules/speaker';
import mediaobject from './modules/mediaobject';
import info from "./modules/info";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {         
        audio: audio,        
        testimonial: testimonial,
        video: video,
        user: user,
        speaker: speaker,
        mediaobject: mediaobject,
        info: info,
        auth: AuthModule ,
        refreshToken: RefreshTokenModule     
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js